import Vue, { PropType } from "vue";
import { ICell } from "js/crossword/types";

import style from "../css/BoardCell.module.css";

export default Vue.extend({
  props: {
    cell: Object as PropType<ICell>,
  },
  render() {
    const { cell } = this;
  
    return (
      <div class={style.identifier}>
        <div>
          { cell.identifier }
        </div>
      </div>
    );
  }
});
